<template>
  <div>

    <div class="tip pb-wide">
      <p>메일 내용에 {이름}, {닉네임}, {회원아이디}, {이메일} 처럼 내용에 삽입하면 해당 내용에 맞게 변환하여 메일을 발송합니다.</p>
    </div>

    <vx-card class="send-form">
      <div class="row">
        <vs-col class="send-form-title">제목</vs-col>
        <vs-col class="send-form-body">
          <vs-input class="w-full" v-model="form.subject"></vs-input>
        </vs-col>
      </div>

      <div class="row">
        <vs-col class="send-form-title">받는사람</vs-col>
        <vs-col class="send-form-body">
          <vs-row>
            <vs-radio class="mr-8" v-model="sendToType" vs-value="toTypeA">수신동의회원</vs-radio>
            <vs-radio class="mr-8" v-model="sendToType" vs-value="toTypeB">전체회원</vs-radio>
            <vs-radio class="mr-8"  v-model="sendToType" vs-value="toTypeC">관리자회원</vs-radio>
            <vs-radio v-model="sendToType" selected value="toTypeD">직접입력</vs-radio>
          </vs-row>
        </vs-col>
      </div>


      <div class="row">
        <vs-col class="send-form-title"></vs-col>
        <vs-col class="send-form-body">
          <vs-input class="w-full" placeholder="다수의 메일을 등록할 경우 ,(콤마) 또는 ;(세미콜론)으로 구분해 주세요" v-model="form.to"></vs-input>
        </vs-col>
      </div>


      <div class="row">
        <vs-col class="send-form-title">권한</vs-col>
        <vs-col class="send-form-body">
          <v-select multiple :closeOnSelect="false" v-model="selected" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </vs-col>
      </div>


      <div class="row">
        <vs-col class="send-form-title">내용</vs-col>
        <vs-col class="send-form-body">
          <quill-editor id="sendmailEditor" class="vx-col flex-1 ql-edit-text" v-model="form.content" :options="quillOption"></quill-editor>
        </vs-col>
      </div>

    </vx-card>

    <div class="flex flex-wrap items-center justify-center">
      <vs-button class="my-5" @click="handleRegister">작성</vs-button>
      <vs-button class="ml-5" type="border" @click="handleCancel">취소</vs-button>
    </div>
  </div>
</template>

<script>

import moduleSendmail from '@/store/sendmail/sendmailModule.js'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import vSelect from 'vue-select'
import {quillEditor} from 'vue-quill-editor'

export default {
  name: 'MemberSendMailDetail',
  components: {quillEditor, vSelect},
  data () {
    return {
      options:['A팀', 'B팀', 'C팀'],
      selected:[],
      contentInput:'',
      quillOption: {
        placeholder: '내용을 입력해주세요 ...'
      },

      sendToType:'toTypeD',

      form:{
        subject:'',
        to:'',
        cc:'',
        bcc:'',
        content:''
      }
    }
  },

  created () {
    // store module 등록 (API 호출시 사용됨)
    if (!this.$store.hasModule('sendmail')) {
      this.$store.registerModule('sendmail', moduleSendmail)
    }
  },

  methods:{
    handleCancel () {
      this.$router.back()
    },

    async sendMail () {
      const to = this.getEmailStringListToJSONString(this.form.to)
      const cc = this.getEmailStringListToJSONString(this.form.cc)
      const bcc = this.getEmailStringListToJSONString(this.form.bcc)
      const subject = this.form.subject
      const content = this.form.content

      await this.$store.dispatch('sendmail/SEND_MAIL', {to, cc, bcc, subject, content})
    },

    handleRegister () {
      this.sendMail()
    },

    getEmailStringListToJSONString (emailListString) {
      const list = []
      const strList = emailListString.split(',')
      for (const email of strList) {
        if (email.trim().length > 0) {
          list.push(email.trim())
        }
      }

      return JSON.stringify(list)

    }
  }
}
</script>

<style>
.send-form .row { margin-bottom:1.5rem; display: grid !important; grid-template-columns: 80px 1fr;}
#sendmailEditor .ql-container.ql-snow { height:600px; }
</style>

<style scoped>
.pb-wide{ margin-bottom:1.5rem !important;}
.tip { padding:24px; background-color: #fff; }
.tip p {color:#757575}
.tip p.warning {color:red; font-weight: 500}


</style>

